/* @jsxImportSource react */

import config from '@packages/config';

import { SlotsContainer } from './Base/SlotsContainer';
import { SlotLoading } from './Base/Slot.loading';

export const SlotsDefaultLoading = () => {
  const {
    headerSlots: { payback, localeSwitcher, joe, serviceApi },
  } = config;

  return (
    <SlotsContainer>
      {localeSwitcher && <SlotLoading priority={5} />}
      {payback && <SlotLoading priority={6} />}
      {joe && <SlotLoading priority={6} />}
      {serviceApi && <SlotLoading priority={999} />}
      {/* account */}
      <SlotLoading priority={2} />
      {/* search slot is also hidden on checkout routes, but we'll just ignore that and hope it uses the minimal header anyways */}
      <SlotLoading priority={1} className="lg:hidden" />
      {/* wishlist */}
      <SlotLoading priority={4} />
      {/* basket */}
      <SlotLoading priority={3} />
    </SlotsContainer>
  );
};
